module.exports = __webpack_public_path__ + "static/media/1_4.d3f69719.jpg";